var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.932 0.471777C10.6013 0.129705 10.0671 0.129705 9.73639 0.471777L5.59 4.75207L1.44361 0.463006C1.11291 0.120933 0.578714 0.120933 0.24802 0.463006C-0.0826735 0.805079 -0.0826735 1.35766 0.24802 1.69973L4.39441 5.9888L0.24802 10.2779C-0.0826735 10.6199 -0.0826735 11.1725 0.24802 11.5146C0.578714 11.8567 1.11291 11.8567 1.44361 11.5146L5.59 7.22552L9.73639 11.5146C10.0671 11.8567 10.6013 11.8567 10.932 11.5146C11.2627 11.1725 11.2627 10.6199 10.932 10.2779L6.78559 5.9888L10.932 1.69973C11.2542 1.36643 11.2542 0.805079 10.932 0.471777Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/white-cross.3ad7f82a380ca8c1610dc8731bdf4ab2.svg";
export { ForwardRef as ReactComponent };